import React from "react";
import { useSnapshot } from 'valtio'
import Select,  { Color } from '../components/Select'
import CustomizerContext from "../CustomizerContext";
import { PillowFabrics } from "../ChairModel";


const SelectPillowColor = (props) => {
    
    const snap = useSnapshot(CustomizerContext)
    
    return(
        <div className="space-y-4 pt-4">
            
                <span className="font-bold">Pillow Color</span>
                    <Select default={snap.pillow.fabric} updateEvent={(color) => { CustomizerContext.pillow.fabric = color }}>
                        <Color value={PillowFabrics.yellow} color="bg-yellow-400 hover:bg-yellow-500" />
                        <Color value={PillowFabrics.flower} color="bg-gray-50 hover:bg-gray-100" />
                        <Color value={PillowFabrics.strip} color="bg-red-500 hover:bg-red-800" />
                    </Select>
        </div>
    )
}

export default SelectPillowColor